// import Swiper from "../vendor/swiper.min.js";
import Swiper from "swiper";
import breakpoints from "../../json/breakpoints.json";

export class complexSlider {
    constructor() {
        if (this.slider) {
            [...this.slider].forEach(slider => {
                const thumbs = slider.querySelector(
                    ".js-complex-slider-thumbs"
                );
                const slides = slider.querySelector(
                    ".js-complex-slider-slides"
                );

                this.init(thumbs, slides);
                this.addEventListeners(slider, thumbs, slides);
            });
        }
    }

    get slider() {
        return document.querySelectorAll(".js-complex-slider") || false;
    }

    init(thumbs, slides) {
        const numSlides = slides.querySelectorAll("li").length;
        const thumbsSlider = new Swiper(thumbs, {
            slidesPerView: 2,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            loop: true,
            loopedSlides: numSlides,
            spaceBetween: 0,
            hashNavigation: {
                replaceState: true
            },
            navigation: {
                nextEl: ".js-next",
                prevEl: ".js-prev"
            },
            breakpoints: {
                [breakpoints.xs]: {
                    centeredSlides: true,
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                [breakpoints.s]: {
                    centeredSlides: true,
                    slidesPerView: "auto",
                    spaceBetween: 8
                }
            }
        });

        const slidesSlider = new Swiper(slides, {
            centeredSlides: true,
            slidesPerView: 1,
            simulateTouch: false,
            noSwiping: true,
            allowTouchMove: false,
            loop: true,
            loopedSlides: numSlides,
            autoHeight: true,
            hashNavigation: {
                replaceState: true
            },
            observer: true,
            observeParents: true,
            observeSlideChildren: true
        });

        thumbsSlider.controller.control = slidesSlider;
    }

    addEventListeners(slider, thumbs, slides) {
        const slideInstances = slider.querySelectorAll(".js-slide");
        [...slideInstances].forEach(
            slide => {
                const readMoreTrigger = slide.querySelector(".js-expand-slide");
                readMoreTrigger.addEventListener("click", e => {
                    const activeSlideContent = e.target.closest(
                        ".js-slide-content"
                    );
                    e.preventDefault();
                    this.expandSlide(activeSlideContent, slides);
                });
            },
            { once: true }
        );

        slides.swiper.on("slideChange", () => {
            [...slideInstances].forEach(slide => {
                const slideContent = slide.querySelector(".js-slide-content");
                this.closeSlide(slideContent, slides);
            });
            slides.swiper.update();
        });

        thumbs.swiper.on("slideChange", () => {
            slides.swiper.update();
        });
    }

    expandSlide(activeSlideContent, slides) {
        activeSlideContent.classList.add("active");
        setTimeout(() => {
            activeSlideContent.classList.add("expanded");
            slides.swiper.updateAutoHeight();
        }, 50);
    }

    closeSlide(activeSlideContent) {
        activeSlideContent.classList.remove("active");
        activeSlideContent.classList.remove("expanded");
    }
}

export class simpleSlider {
    constructor() {
        if (this.slider) {
            [...this.slider].forEach(slider => {
                this.init(slider);
            });
        }
    }

    get slider() {
        return document.querySelectorAll(".js-simple-slider") || false;
    }

    init(slider) {
        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: ".js-next",
                prevEl: ".js-prev"
            }
        });
    }
}
